import React from 'react';
import { useAppSelector } from '../Store/store.ts';
import { CurrentStepSelector } from '../Selectors/FitAssistantSelectors.ts';
import FitAssistantStep from '../Enums/FitAssistantStep.ts';
import MountingSelector from '../Components/MountingSelector/MountingSelector.tsx';
import NoFit from '../Components/NoFit/NoFit.tsx';
import OtherFits from '../Components/OtherFits/OtherFits.tsx';
import PlatformsRackSelector from '../Components/RackSelector/PlatformsRackSelector.tsx';
import RackMountingSelector from '../Components/RackMountingSelector/RackMountingSelector.tsx';
import SelectList from '../Components/SelectList/SelectList.tsx';
import Unconfirmed from '../Components/Unconfirmed/Unconfirmed.tsx';
import VariationSelector from '../Components/VariationSelector/VariationSelector.tsx';
import NoFitPlatforms from '../Components/NoFit/NoFitPlatforms.tsx';

export const RoofPlatforms = () => {
  const currentStep = useAppSelector(CurrentStepSelector);

  const RenderStep = () => {
    switch (currentStep) {
      case FitAssistantStep.Mounting:
        return <MountingSelector />;
      case FitAssistantStep.RackMounting:
        return <RackMountingSelector />;
      case FitAssistantStep.Make:
      case FitAssistantStep.Model:
      case FitAssistantStep.Year:
        return <SelectList />;
      case FitAssistantStep.Variation:
        return <VariationSelector />;
      case FitAssistantStep.RoofRacks:
        return <PlatformsRackSelector />;
      case FitAssistantStep.NoFits:
        return <NoFitPlatforms />;
      case FitAssistantStep.OtherFits:
        return <OtherFits />;
      case FitAssistantStep.Unconfirmed:
        return <Unconfirmed />;
      default:
        return <></>;
    }
  };

  return <>{RenderStep()}</>;
};

export default RoofPlatforms;
